import { FC, memo } from "react";

import FloorPlan from "../../Order/Cards/OrderService/FloorPlan";
import GenericCustomerService from "../../Order/Cards/OrderService/GenericCustomerService";
import { OrderCustomerProps } from "../OrderCustomer.interface";
import Photo from "../../Order/Cards/OrderService/Photo";
import {ShareOrderCard } from "../../Order/Cards";
import { getGroupedOrderServices } from "@/helpers";
import WalklyService from "../../Order/Cards/OrderService/WalklyService";

const WorkDone: FC<OrderCustomerProps> = ({
    logoUrl,
    onConfirmFiles,
    onChooseDraftFiles,
    onDownloadFiles,
    onShareOrder,
    orderDetails
}) => {

  const { photoService, floorPlanService, virtualTourService, virtualStagingService, imagemotionVideoService, walklyService, remainingServices } = getGroupedOrderServices(orderDetails?.services || []);

    const customerServices = [virtualTourService, virtualStagingService,  ...remainingServices ];

    const handleShareOrder = (email: string) => {
        onShareOrder?.(email);
    };

    return (<>
    
        {photoService && <Photo
            branchId={orderDetails.branchId}
            amount={photoService.amount}
            draftFiles={photoService.draftUploadFiles}
            logoUrl={logoUrl}
            name={photoService.name}
            notifications={photoService.notifications}
            orderPrice={orderDetails.orderPrice}
            orderState={orderDetails.orderState}
            orderId={orderDetails.id}
            selectedWorkerName={photoService.applicationUserName}
            serviceId={photoService.orderServiceId}
            type={photoService.type}
            uploadedFiles={photoService.uploadFiles}
            onConfirmFiles={onConfirmFiles}
            onChooseDraftFiles={onChooseDraftFiles}
            onDownloadFiles={onDownloadFiles}
        /> }

        {floorPlanService && <FloorPlan
            draftFiles={floorPlanService.draftUploadFiles}
            logoUrl={logoUrl}
            name={floorPlanService.name}
            notifications={floorPlanService.notifications}
            orderState={orderDetails.orderState}
            selectedWorkerName={floorPlanService.applicationUserName}
            serviceId={floorPlanService.orderServiceId}
            type={floorPlanService.type}
            uploadedFiles={floorPlanService.uploadFiles}
            onDownloadFiles={onDownloadFiles}
        /> }

        {virtualStagingService && <Photo
                    branchId={orderDetails.branchId}
                    amount={virtualStagingService.amount}
                    draftFiles={virtualStagingService.draftUploadFiles}
                    logoUrl={logoUrl}
                    name={virtualStagingService.name}
                    notifications={virtualStagingService.notifications}
                    orderPrice={orderDetails.orderPrice}
                    orderState={orderDetails.orderState}
                    orderId={orderDetails.id}
                    selectedWorkerName={virtualStagingService.applicationUserName}
                    serviceId={virtualStagingService.orderServiceId}
                    type={virtualStagingService.type}
                    uploadedFiles={virtualStagingService.uploadFiles}
                    onConfirmFiles={onConfirmFiles}
                    onChooseDraftFiles={onChooseDraftFiles}
                    onDownloadFiles={onDownloadFiles}
                /> }
        
        {walklyService && walklyService.externalLink && <WalklyService
             externalUrl={walklyService.externalLink}
             label={walklyService.label || ''}
             name={walklyService.name}
             selectedWorkerName={walklyService.applicationUserName}
             serviceId={walklyService.orderServiceId}
             type={walklyService.type}
             />
        }

        { customerServices.map((item) => {
            return item && (
                <GenericCustomerService
                    key={item.orderServiceId}
                    label={item.label || 'Link'}
                    name={item.name}
                    notifications={item.notifications}
                    externalUrl={item.externalLink || ''}
                    selectedWorkerName={''}
                    serviceId={item.orderServiceId}
                    type={item.type}
                     />
            );
        })}

        <ShareOrderCard
            orderId={orderDetails?.id || ''}
            onShareOrder={handleShareOrder}
        />

    </>)
}

export default memo(WorkDone);